import * as React from 'react';

import {Button} from 'shells/button/button';
import type {ButtonStyleProps} from 'shells/button/button';

import {launchIntercomMessenger} from './launch-intercom-messenger';

type Props = ButtonStyleProps & {
    children: React.ReactNode;
};

/**
 * This component utilizes the newly added intercom hook and our existing button component.
 *
 * P.S. to get this working in dev see the "How this all works" section in https://github.com/nutshellcrm/nutshell/pull/11985
 */
export function IntercomLaunchButton(props: Props) {
    return (
        <Button
            {...props}
            onClick={launchIntercomMessenger}
            data-tip='Nutshell support'
            data-place='bottom'
            data-delay-show={50}
        >
            {props.children}
        </Button>
    );
}
